module.exports = __webpack_public_path__ + "static/media/antecna-a-logo.2d605194.svg";